<script lang="ts">
    import {TabGroup} from '@rgossiaux/svelte-headlessui';

    export let initiallySelected = 0;
    export let additionalClasses = '';
</script>

<TabGroup defaultIndex="{initiallySelected}"
          class="kp-generic-tab-group {additionalClasses}"
          on:change>
    <slot/>
</TabGroup>